<template>
    <div style="background:#affbff;margin: 30px -50px 50px -50px;padding: 20px 50px 50px 50px;">
      <div v-if="debug_show_page_name==true" style="color:green;">page_0041_master_maker_detail</div>
        <div :class="'' ">
          <div class="row" style="margin-bottom:10px;">
            <div class="col-xs-12" style="">
              <field-box   v-for="f in formFields.col1"  v-bind:key="f.id" v-bind:data="f"  :read="readOnly" :val="values[f.id]"></field-box>
            </div>
          </div>
          <div class="col-xs-12" style="">
            <div class="row" style="margin-bottom:10px;">
              <button v-if="buttonsMode == 'new'"  class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;margin-right:5px;"  @click="onSave" >割当依頼を送信する</button>
              <button
              v-show ="buttonsMode == 'review'"
              :disabled="disableReviewButtons || checkUserPermission(true,permissionMode.EDIT) == false"
              @click="approve"
              class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-right: 10px;background: #92D050;border-color:#92D050;">確認</button>
              <button
              v-show ="buttonsMode == 'review'"
              :disabled="disableReviewButtons || checkUserPermission(true,permissionMode.EDIT) == false"
              @click="reject"
              class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-right: 10px;background: #FF7C80;border-color:#FF7C80;">差戻</button>
            </div>
          </div>
      </div>
      <confirmation-modal tag="onSavedInformation" @done="onSavedConfirmation" />
      <confirmation-modal tag="notificationApproveReject" @done="onNotificationApproveRejectConfirmation" />

    </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import { fields, filed_types } from '@/rules/fields_surplus_license';
import { utils } from '@/libs/utils';
import _debug from 'debug';
var mdebug = _debug('esma:surplus_license_details');
import fieldBoxes from '@/components/form-field';
import acl from '@/rules/acl_rules';
import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';
import { bus } from '@/libs/bus';
export default {
  mixins: [mixinPageCommon,mixinDatasource],
    components: {
    'field-box': fieldBoxes,
  },
  data() {
    return {
      api_name:"surplus_license_request",//
      page_acl: acl.surplus_license_detail,
      state_current_editing:"current_editing2",
      state_current_row:"current_row2",
      state_is_editing_new:"is_editing_new2",
      state_last_filter_options:"last_filter_options2",
      buttons_mode:"new",
      local_seq_id:-1,
      return_timer:false
    };
  },
  computed: {
    disableReviewButtons(){
      return this.approvalStatus != "未対応"
    },
    approvalStatus(){
      return this.$store.state[this.stateCurrentRow].approval_status || "";
    },
    localSeqID:{
      get(){
        return this.local_seq_id;
      },
      set(v){
        this.local_seq_id = v;
      }
    },
    buttonsMode:{
      get(){
        return this.buttons_mode;
      },
      set(v){
        this.buttons_mode = v;
      }
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    formFields() {
      return {
        col1:[
          this.local_extend(fields.jurisdiction_department, {}),
          this.local_extend(fields.jurisdiction_team, {}),
          this.local_extend(fields.desired_number, {}),
          this.local_extend(fields.requester, {})
        ],
      }
    }
  },
  methods: {
    approve(){
      this.approve_reject("approve");
    },
    reject(){
      this.approve_reject("reject");
    },
    onNotificationApproveRejectConfirmation(mode){
      
      if(mode == "yes" || mode == "no"){
        clearTimeout(this.return_timer);
        this.return_timer = setTimeout(()=>{
          return this.$router.push({ name: "page_0020_surplus_license_request", params: {} });
        },600)
      }
    },
    approve_reject(mode){
         this.$ajax.post('/'+this.api_name+'/'+mode+'/' + this.localSeqID, {}, (err, result) => {
          if(err){
            this.$notify({
              title: 'Failed to '+mode+' data',
              text: err,
              type: 'error',
              duration: 10000
            });
          }else{
            bus.$emit("notificationApproveReject",{
              message: "",
              title: (mode == "approve")?"余剰ライセンスの割当依頼を承認します。<br>よろしいですか？":"申請を差戻しました。",
              yes_label: (mode == "approve")?"承認する(割当通知発行)":"",
              no_label: "戻る",
              yes_color:"primary",
              no_color:"",
              model_height:"50"
            });
          }
        })
    },
    onSavedConfirmation(mode){
      if(mode == "no"){
        this.backToList();
      }
    },
    local_extend(field_info,ext){
      ext.state_current_row = this.stateCurrentRow;
      ext.state_current_editing = this.stateCurrentEditing;
      return utils.extend(field_info,ext)
    },
    onSave(){
      this.read_only = false;
      this.commonSaveInfo(this,this.api_name, {} ,(err)=>{
        if(!err){
          bus.$emit("onSavedInformation",{
            title: "",
            message: "余剰ライセンスの割当依頼を送信しました。",
            yes_label: "",
            no_label: "戻る",
            yes_color:"",
            no_color:"primary",
            model_height:"50"
          });
        }
      });
    },
    backToList(){
      if(this.buttonsMode == "new"){
        return this.$router.push({ name: "page_0020_surplus_license", params: {} });
      }else{
        return this.$router.push({ name: "page_0020_surplus_license_request", params: {} });
      }
    }
  },
  mounted() {
    if(this.$props.create_new == true){
      this.buttonsMode = "new";
      this.$route.params.seq_id = "new"
    }else{
      this.buttonsMode = "review";
      this.$route.params.seq_id = this.$props.seq_id;
      this.localSeqID = this.$props.seq_id;
    }
    this.commonLoadRecord({},(err,result)=>{
      this.$store.state[this.stateCurrentEditing]["surplus_license_seq_id"] = this.$props.ref_id;
      // this.commonEditDeleteCmdHandler(this);
    })
  },
  beforeDestroy() {
  },
  beforeMount() {
  },
  props: {
    ref_id: { type: Number },
    seq_id: { type: String },
    create_new: { type: Boolean, default: false }
  },
};

</script>
<style scoped>

input:focus::-webkit-input-placeholder {
  color: transparent;
}
</style>



// WEBPACK FOOTER //
// surplus_license_sub_page.vue?520ea472